<template>
  <div class="modern-suggestion">
    <span class="modern-suggestion-title"> {{ suggestionText }} </span>
    <v-btn class="modern-suggestion-action-button" color="primary" @click="onClick">
      {{ actionText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ModernSuggestionWithAction',
  props: {
    suggestionText: {
      type: String,
      required: true,
    },
    actionText: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.modern-suggestion {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.modern-suggestion-title {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}
</style>

<style lang="scss">
.modern-suggestion-action-button {
  min-width: 100px !important;
  height: 40px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(143, 36, 208, 0.25) !important;
  transition: all 0.2s ease !important;

  &:hover {
    box-shadow: 0 3px 10px rgba(143, 36, 208, 0.35) !important;
    transform: translateY(-1px) !important;
  }
}
</style>
